import type {
  ToothMPRSliceOptions,
  ToothMPRSliceOptions_SeriesOptions,
} from '@/shared/api/protocol-ts/model/dto_report_tooth_pb';
import type { ToothBasisSeriesName } from '@/shared/graphics/medicalImageRender/MedicalImageRender';

import { DEFAULT_TOOTH_SLICE_OPTIONS_BY_SERIES } from '../config';
import type { ToothSliceOptions, ToothSliceOptionsBySeries } from '../config';

import { resolveToothSliceOptionsBySeries } from './resolveToothSliceOptionsBySeries';

const resolveSeriesOptions = ({
  fallback,
  proto,
}: {
  fallback: ToothSliceOptions;
  proto: ToothMPRSliceOptions_SeriesOptions | undefined;
}): ToothSliceOptions => {
  if (!proto || proto.ThicknessMm <= 0 || proto.SliceStepMm <= 0) {
    return fallback;
  }

  return {
    sliceStepMm: proto.SliceStepMm,
    thicknessMm: proto.ThicknessMm,
  };
};

export const resolveServerToothSliceOptions = ({
  proto,
  thicknessOptionsMm,
}: {
  proto: ToothMPRSliceOptions | null;
  thicknessOptionsMm: number[];
}): ToothSliceOptionsBySeries => {
  const protoBySeries: Record<
    ToothBasisSeriesName,
    ToothMPRSliceOptions_SeriesOptions | undefined
  > = {
    axial: proto?.Axial,
    sagittal: proto?.VestibuloOral,
    frontal: proto?.MesioDistal,
  };

  const optionsBySeries: ToothSliceOptionsBySeries = {
    axial: resolveSeriesOptions({
      fallback: DEFAULT_TOOTH_SLICE_OPTIONS_BY_SERIES.axial,
      proto: protoBySeries.axial,
    }),
    sagittal: resolveSeriesOptions({
      fallback: DEFAULT_TOOTH_SLICE_OPTIONS_BY_SERIES.sagittal,
      proto: protoBySeries.sagittal,
    }),
    frontal: resolveSeriesOptions({
      fallback: DEFAULT_TOOTH_SLICE_OPTIONS_BY_SERIES.frontal,
      proto: protoBySeries.frontal,
    }),
  };

  return resolveToothSliceOptionsBySeries({
    optionsBySeries,
    thicknessOptionsMm,
  });
};
